
<template>
    <div class="container">
        <img src="../../assets/img/e_pic_register1.png" alt class="state-img" />
        <div class="tips" v-show="$route.params.message">{{$route.params.message}}</div>
        <div class="content">
            <van-field label="银行账户类型" value="个人银行账户" disabled />
            <van-field label="会员证件类型" value="身份证" disabled />
            <van-field label="身份证号码" v-model="identity" placeholder="请输入身份证号码" maxlength="18" />
            <van-field label="持卡人姓名" v-model="name" placeholder="请输入持卡人姓名" />
            <van-field label="银行卡号" v-model="cardNumber" placeholder="请输入银行卡号" maxlength="19" type="number"
                @blur="onBlur" />
            <van-field label="预留手机号" v-model="phone" placeholder="请输入预留手机号" maxlength="11" type="number" />
            <van-field label="开户银行" v-model="bankClsName" right-icon="arrow" placeholder="请选择开户银行" disabled
                @click="clickBank" />
            <van-field label="银行所在区域" v-model="site" right-icon="arrow" placeholder="省-市-区" disabled
                @click="clickSite" />
            <van-field label="开户行支行" v-model="subBranch" right-icon="arrow" placeholder="请选择开户银行支行" disabled
                @click="clickSub" />
        </div>
        <van-button class="btn" text="下一步" @click="gotoNext" />
        <van-popup v-model="bankShow" position="bottom">
            <div>
                <van-search placeholder="请输入搜索关键词" background="#f7f8fa" v-model="keyBank" @input="bankAlter" />
                <div class="chidden">
                    <div v-for="(item,index) in bankList" :key="index" class="silver" @click="btnBankName(item)"
                        :style="bankClsName==item.bankClsName?'color:#FF1310':''">
                        {{item.bankClsName}}
                        <div v-if="bankClsName==item.bankClsName" class="box"></div>
                    </div>
                    <div class="noneImg" v-if="bankList.length==0">
                        <img src="../../assets/img/e_pic_miss_search.png" alt />
                        <p>暂无搜索结果</p>
                    </div>
                </div>
            </div>
        </van-popup>
        <van-popup v-model="siteShow" position="bottom">
            <div>
                <div class="flex">
                    <div class="chidden">
                        <div v-for="(item,index) in siteList" :key="index" class="silver" @click="btnsite(item)"
                            :style="province==item.nodeNodename?'color:#FF1310':''">
                            {{item.nodeNodename}}
                            <div v-if="province==item.nodeNodename" class="box"></div>
                        </div>
                    </div>
                    <div class="chidden">
                        <div v-for="(item,index) in citytList" :key="index" class="silver" @click="btncity(item)"
                            :style="city==item.cityAreaName?'color:#FF1310':''">
                            {{item.cityAreaName}}
                            <div v-if="city==item.cityAreaName" class="box"></div>
                        </div>
                    </div>
                    <div class="chidden">
                        <div v-for="(item,index) in districtList" :key="index" class="silver" @click="btndistrict(item)"
                            :style="district==item.cityAreaName?'color:#FF1310':''">
                            {{item.cityAreaName}}
                            <div v-if="district==item.cityAreaName" class="box"></div>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
        <van-popup v-model="subShow" position="bottom">
            <div>
                <van-search placeholder="请输入搜索关键词" background="#f7f8fa" v-model="keySub" @input="subAlter" />
                <div class="chidden">
                    <div v-for="(item,index) in subList" :key="index" class="silver" @click="btnBranch(item)"
                        :style="subBranch==item.bankName?'color:#FF1310':''">
                        {{item.bankName}}
                        <div v-if="subBranch==item.bankName" class="box"></div>
                    </div>
                    <div class="noneImg" v-if="subList.length==0">
                        <img src="../../assets/img/pic_miss_search.png" alt />
                        <p>暂无搜索结果</p>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
import {
    expertGetBindingBankClsCodeList,
    expertGetBindingProvinceList,
    expertGetBindingCityList,
    expertGetBindingBankInfoList,
    expertGetBindingCardList
} from "@/api/expert";

export default {
    data() {
        return {
            identity: "", //身份证号码
            name: "", //姓名
            cardNumber: "", //银行卡号
            phone: "", //手机号
            bankClsName: "", //开户银行
            site: "", //省-市-区
            province: "", //省
            city: "", //市
            district: "", //区
            keySite: "", //搜索省关键字
            keyBank: "", //搜索银行关键字
            keySub: "", //搜索支行关键字
            subBranch: "", //开户银行支行
            bankShow: false, // 选择大银行弹出层
            siteShow: false, // 选择省市区弹出层
            subShow: false, //选择支行弹出层
            bankClsCode: "", // 银行ID
            nodeNodecode: "", //省ID
            cityOraareaCode: "", //市ID
            bankList: [], // 主银行列表
            siteList: [], //省数组
            citytList: [], //市数组
            districtList: [], //区数组
            subList: [], //支行
            backCardList: [], //银行卡列表
        };
    },
    methods: {
        onBlur() {
            let flag = false;
            for (let i = 0; i < this.backCardList.length; i++) {
                if (this.backCardList[i].acctId == this.cardNumber) {
                    flag = true;
                    break;
                }
            }
            if (flag) {
                this.$toast("该银行卡已绑定过");
            }
            return flag;
        },
        bankAlter(val) {
            //银行搜索调接口
            this.expertGetBindingBankClsCodeList(val);
        },
        siteAlter(val) {
            //省搜索调接口
            this.expertGetBindingProvinceList(val);
        },
        subAlter(val) {
            //支行搜索调接口
            this.clickSub(val);
        },
        clickSite() {
            //点击弹出省市区弹出层
            if (this.bankClsName.length == 0) {
                return;
            }
            this.expertGetBindingProvinceList();
            this.siteShow = true;
        },
        clickBank() {
            //点击弹出开户银行弹出层
            this.expertGetBindingBankClsCodeList();
            this.bankShow = true;
        },
        clickSub(val) {
            //点击弹出银行支行弹出层
            if (this.site.length == 0) {
                return;
            }
            this.expertGetBindingBankInfoList();
            this.subShow = true;
        },
        expertGetBindingBankClsCodeList(val) {
            //搜索开户银行关键字
            expertGetBindingBankClsCodeList({
                bankClsName: val ? val : this.keyBank, //总行关键字(用于模糊匹配)
            }).then((res) => {
                if (res.appStatus.errorCode == 0) {
                    this.bankList = res.content;
                }
            });
        },
        expertGetBindingProvinceList(val) {
            //省份
            expertGetBindingProvinceList({
                province: val ? val : this.keySite, // 省份关键字 可选
            }).then((res) => {
                if (res.appStatus.errorCode == 0) {
                    this.siteList = res.content.list;
                }
            });
        },
        expertGetBindingCityList(code) {
            //省搜索市
            expertGetBindingCityList({
                cityNodeCode: code, //省份编码
            }).then((res) => {
                if (res.appStatus.errorCode == 0) {
                    this.citytList = res.content.list;
                }
            });
        },
        getBindingCityList1(code) {
            //市搜索区
            expertGetBindingCityList({
                cityAreaCode: code, //市份编码
            }).then((res) => {
                if (res.appStatus.errorCode == 0) {
                    this.districtList = res.content.list;
                }
            });
        },
        btnBankName(item) {
            //银行总行
            let obj = item;
            this.bankClsCode = obj.bankClsCode;
            this.bankClsName = obj.bankClsName;
            this.bankShow = false;
        },
        btnsite(item) {
            //点击省搜索市
            let obj = item;
            if (this.province != item.nodeNodename) {
                this.districtList = [];
            }
            this.province = item.nodeNodename;
            this.nodeNodecode = item.nodeNodecode;
            this.expertGetBindingCityList(item.nodeNodecode);
        },
        btncity(item) {
            //点击市搜索区
            let obj = item;
            this.city = item.cityAreaName;
            this.cityOraareaCode = item.cityAreaCode;
            this.getBindingCityList1(item.cityAreaCode);
        },
        btndistrict(item) {
            //点击区或者县
            this.district = item.cityAreaName;
            this.cityOraareaCode = item.cityOraareaCode;
            this.site = this.province + "-" + this.city + "-" + this.district;
            this.siteShow = false;
        },
        btnBranch(item) {
            this.subBranch = item.bankName;
            this.bankNo = item.bankNo;
            this.subShow = false;
        },
        expertGetBindingBankInfoList(val) {
            //搜索
            expertGetBindingBankInfoList({
                bankClsCode: this.bankClsCode,
                cityCode: this.cityOraareaCode,
                bankName: val ? val : this.keySub,
            }).then((res) => {
                if (res.appStatus.errorCode == 0) {
                    this.subList = res.content.list;
                }
            });
        },
        gotoNext() {
            //点击下一步
            if (this.identity.length < 15) {
                if (this.identity.length == 0) {
                    this.$toast("请输入身份证号码");
                    return;
                }
                this.$toast("身份证号码输入的信息有误，请检查后重新输入");
                return;
            } else if (this.name.length == 0) {
                this.$toast("请输入持卡人姓名");
                return;
            } else if (this.cardNumber.length < 16) {
                if (this.cardNumber.length == 0) {
                    this.$toast("请输入银行卡号码");
                    return;
                }
                this.$toast("银行卡号码输入的信息有误，请检查后重新输入");
                return;
            } else if (this.cardNumber.length >= 16 && this.onBlur()) {
                return;
            } else if (this.phone.length < 11) {
                if (this.phone.length == 0) {
                    this.$toast("请输入手机号码");
                    return;
                }
                this.$toast("手机号码输入的信息有误，请检查后重新输入");
                return;
            } else if (!this.bankClsName.length) {
                this.$toast("请选择开户银行");
                return;
            } else if (!this.site.length) {
                this.$toast("请选择省市区");
                return;
            } else if (!this.subBranch.length) {
                this.$toast("请选择开户银行支行");
                return;
            }
            let obj = {
                idType: "1", //证件类型 送1（身份证）
                idCode: this.identity, //身份证号
                custName: this.name, //真实姓名
                acctId: this.cardNumber, //银行卡号
                bankName: this.subBranch, //银行名称
                mobilePhone: this.phone, //银行预留手机号
                bankNo: this.bankNo, //大小额行号 BankCode和SBankCode两者二选一必填。（获取银行网点接口返回的bankNo）
                bankCode: this.bankNo, //大小额行号 BankCode和SBankCode两者二选一必填。（获取银行网点接口返回的bankNo）
                paZjjzCnapsBankclscodeId: this.bankClsCode,
                paPubPayCityId: this.cityOraareaCode,
            };
            this.$router.push({
                name: "e_noteCheck",
                path: "/e_noteCheck",
                params: {
                    obj: JSON.stringify(obj),
                },
            });
        },
    },
    mounted() {
        expertGetBindingCardList({}).then((res) => {
            if (res.appStatus.errorCode == 0) {
                this.backCardList = res.content;
            }
        });
    }
};
</script>
<style lang="scss" scoped>
.state-img {
    margin: 15px auto 20px;
    width: 310px;
    height: 55px;
}

.tips {
    width: 360px;
    height: 35px;
    line-height: 35px;
    padding-left: 15px;
    font-size: 14px;
    color: #ff2929;
    background-color: #ffe1e1;
    text-align: center;
}

.content {
    padding: 0 15px;
    background-color: #fff;

    .van-cell {
        padding: 23px 0;
        font-size: 17px;
        color: #333333;
    }
}

.silver {
    padding: 20px;
    font-size: 16px;
    position: relative;
}

.van-search {
    height: 39px;
    padding: 0;
    font-size: 15px;
    margin: 5px 15px;
    border-radius: 5px;
}

.chidden {
    height: 430px;
    overflow-y: scroll;
    font-size: 16px;
}

.box {
    position: absolute;
    top: 29%;
    left: 0;
    width: 4px;
    height: 29px;
    background-color: #ff3838;
}

.flex {
    display: flex;

    .chidden {
        flex: 0 0 33.3%;
    }
}

.btn {
    height: 40px;
    margin: 50px 12px;
    font-size: 16px;
    color: #fff;
    background-color: #FFB14A;
    border-radius: 50px;
}

.noneImg {
    text-align: center;
    color: #C4C4C4;
    font-size: 14px;
    height: 430px;

    img {
        width: 160px;
        height: 160px;
        margin: 70px auto 0;
    }
}
</style>

<style scoped>
.content>>>.van-field__label {
    width: 115px;
    font-size: 16px;
}

.content>>>.van-field--disabled .van-field__label {
    color: initial;
}
</style>